// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__23HtT","productName":"Table_productName__ckR1S"};